export const ImagesKey = 'images';
export const PaymentsKey = 'payments';
export const AutocompleteKey = 'autocomplete';
export const orgs_history = 'orgs_history';
export const projects_history = 'projects_history';
export const trending_orgs = 'trending_orgs';
export const trending_projects = 'trending_projects';
export const reviews = 'reviews_all';
